import React from "react";
import {
	DataRessources,
	DataImages,
	DataInspirations,
	DataTools,
	DataIcons,
	DataColors,
} from "./DataDesign";
import { motion } from "framer-motion";

const containerVariants = {
	hidden: {
		opacity: 0,
		y: 100,
	},
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			type: "tween",
			delay: 0.4,
			duration: 0.4,
		},
	},
	exit: {
		x: " -100vw",
		transition: {
			ease: "easeInOut",
			delay: 0.4,
			duration: 0.4,
		},
	},
};

const Design = () => {
	return (
		<motion.section
			variants={containerVariants}
			initial="hidden"
			animate="visible"
			exit="exit"
			className="blockPage"
		>
			<h2 className="blockPage__text">
				Because it's useful for a Dev to know some design's
				basics
			</h2>
			<h3 className="blockPage__title">Resources</h3>
			<div className="blockPage__content">
				{DataRessources.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
			<h3 className="blockPage__title">Images</h3>
			<div className="blockPage__content">
				{DataImages.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
			<h3 className="blockPage__title">Icons</h3>
			<div className="blockPage__content">
				{DataIcons.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
			<h3 className="blockPage__title">Inspirations</h3>
			<div className="blockPage__content">
				{DataInspirations.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
			<h3 className="blockPage__title">Tools</h3>
			<div className="blockPage__content">
				{DataTools.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
			<h3 className="blockPage__title">Colors</h3>
			<div className="blockPage__content">
				{DataColors.map((item, index) => {
					return (
						<ul key={index} className="blockPage__lists">
							<li className="blockPage__lists--item">
								<a
									className="blockPage__lists--link"
									href={item.path}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={item.cName}
										src={item.icon}
										alt="icon"
									/>
									<p className="blockPage__lists--title">
										{item.title}
									</p>
								</a>
								<p className="blockPage__lists--text">
									{" "}
									{item.description}{" "}
								</p>
							</li>
						</ul>
					);
				})}
			</div>
		</motion.section>
	);
};

export default Design;
